<template>
  <div>
    <van-nav-bar title="加班申请" left-text="返回" right-text="" @click-left="onClickLeft"/>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="加班规则说明" name="1" icon="calendar-o">
        <div style="color: red" v-html="this.workovertimeTypeRemark"></div>
      </van-collapse-item>
    </van-collapse>
    <van-form class="login-form-top">
      <van-field
        readonly
        clickable
        name="workovertimeType"
        :value="workovertimeTypeName"
        label="加班类型"
        placeholder="点击选择加班类型"
        @click="workovertimeTypeShow = true"
        :rules="[{ required: true, message: '请选择加班类型' }]"
      />
      <van-action-sheet v-model="workovertimeTypeShow" :actions="workovertimeTypeList" @select="workovertimeTypeClick"/>

      <van-field
        readonly
        clickable
        name="beginTime"
        :value="beginTime"
        label="开始时间"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择开始时间' }]"
        @click="showBeginCalendar = true"
      />
      <van-calendar :show-confirm="false" v-model="showBeginCalendar" @confirm="onBeginConfirm"
                    :min-date="minDate" :max-date="maxDate"/>
      <van-field
        readonly
        clickable
        name="endTime"
        :value="endTime"
        label="结束时间"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择结束时间' }]"
        @click="showEndCalendar = true"
      />
      <van-calendar :show-confirm="false" v-model="showEndCalendar" @confirm="onEndConfirm"
                    :min-date="minDate" :max-date="maxDate"/>
      <van-field name="radio" label="时间段" v-if="isHalfShow">
        <template slot="input">
          <van-radio-group v-model="dayHalf" direction="horizontal" @change="halfChange()">
            <van-radio :name="item.dictKey" v-for="item in dayHalfList" :key="item.dictKey">
              {{ item.dictValue }}
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        readonly
        v-model="day"
        name="day"
        label="加班天数"
        placeholder="加班天数"
        :rules="[{ required: true, message: '请填写加班天数' }]"
      />
      <van-field
        v-model="reason"
        rows="3"
        autosize
        label="加班原因"
        type="textarea"
        maxlength="50"
        placeholder="请填写加班原因"
        show-word-limit
      />
      <van-field name="applyFile" label="附件">
        <template slot="input">
          <van-uploader :before-read="beforeApplyFileRead" :after-read="afterApplyFileRead"
                        :max-size="5000 * 1024" max-count="6" v-model="showFiles" multiple
                        :before-delete="beforeApplyFileDelete"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
          </van-uploader>
        </template>
      </van-field>

    </van-form>
    <!--    <div style="margin: 16px;">-->
    <!--      <van-button round block type="primary" native-type="submit" @click="taskSave">保存</van-button>-->
    <!--    </div>-->
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="taskSubmit">提交</van-button>
    </div>

    <van-dialog v-model="roleShow" title="我的角色" show-cancel-button @confirm="roleCommit" confirmButtonText="提交">
      <van-radio-group v-model="roleRadio">
        <van-cell-group>
          <van-cell :title="item.roleName" clickable v-for="item in roleList" :key="item.roleAlias"
                    clickable @click="roleRadio = item.roleAlias">
            <template slot="right-icon">
              <van-radio :name="item.roleAlias"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
    <ProcessDialog ref="showProcessDialog" :submitFlowMethod="submitFlowMethod"
                   :getFlowParamsMethod="getFlowParamsMethod"/>
  </div>
</template>

<script>

import {Dialog, Toast} from "vant";
import Vue from "vue";
import moment from "moment";
import {isLogin, isWechat, replaceUrl} from "../../../utils/util";

export default {
  name: "workOverTimeForm",
  data() {
    return {
      activeNames: ['1'],
      taskId: '',
      processInstanceId: '',
      processDefinitionId: '',
      appNo: '',
      workovertimeTypeList: [],
      workovertimeType: '',
      workovertimeTypeName: '',
      workovertimeTypeShow: false,
      workovertimeTypeRemark: '',
      day: 0,
      dayHalf: 0,
      isHalfShow: false,
      dayHalfList: [],
      showBeginCalendar: false,
      beginTime: '',
      showEndCalendar: false,
      endTime: '',
      realName: '',
      deptName: '',
      userInfo: {},
      workOvertimeId: 0,
      choseRoleId: '',
      nextProcess: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2099, 0, 31),
      trafficDay: 0,
      destination: '',
      reason: '',
      showFiles: [],
      allFiles: {
        applyFiles: [],
        removedFiles: [],
      },
      applyFileIds: [],
      workYear: 0,
      roleShow: false,
      roleRadio: 0,
      roleList: [],
      pageType: 0,
      processShow: false,
      modelKey: "workovertime",
      workOverForm: {},
    };
  },
  mounted() {
    if (!isLogin()) {
      this.$router.push({
        path: "/attenceflow/Error",
        query: {}
      });
    }
    this.appNo = this.$route.query.appNo;
    this.processInstanceId = this.$route.query.processInstanceId;
    this.taskId = this.$route.query.taskId;
    this.processDefinitionId = this.$route.query.processDefinitionId;
    this.workOvertimeId = this.$route.query.workOvertimeId;
    this.pageType = this.$route.query.pageType;
    this.initUserInfo();
  },
  methods: {
    initUserInfo() {
      this.getUserInfo();
    },
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.realName = user.realName;
          this.deptName = user.deptName;
          this.userInfo = user;
          this.workYear = user.workYear;
          this.dictionaryInit();
        }
      );
    },
    //获取基础数据 当前登陆人员加班编号等
    getInitData() {
      //如果当前流程已数据
      this.$fetch("/attence-api/blade-workovertime/workovertime/flowDetailByFlowAppNo", {
        flowAppNo: this.appNo,
      }).then(res => {
        const data = res.data;
        if (data.id != undefined) {
          this.workOvertimeId = data.id;
          this.beginTime = data.beginTime;
          this.endTime = data.endTime;
          this.workovertimeType = data.workovertimeType;
          this.workovertimeTypeList.forEach(v => {
            if (this.workovertimeType == v.dictKey) {
              this.workovertimeTypeName = v.dictValue;
            }
          });
          this.day = data.day;
          this.dayHalf = data.halfDay + "";
          //如果是同一天则放开时间段选项
          if (this.beginTime == this.endTime) {
            this.isHalfShow = true;
          } else {
            this.isHalfShow = false;
          }
          this.reason = data.reason;
          this.allFiles = data.allFiles;
          this.showFiles = data.allFiles.applyFiles;
          this.showFiles.forEach(v => {
            this.applyFileIds.push(v.id);
            v.url = replaceUrl(v.viewUrl);
          });
          this.workOverForm = data;
        }
      });
    },
    dictionaryInit() {
      this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
        code: 'workovertime_type'
      }).then(res => {
        const data = res.data;
        this.workovertimeTypeList = data;
        this.workovertimeTypeList.forEach(v => {
          v.name = v.dictValue;
        });
        this.$fetch("/attence-api/blade-system/dict-biz/dictionary-tree", {
          code: 'halfday'
        }).then(res => {
          const data = res.data;
          this.dayHalfList = data;
          this.getInitData();
        });
      });
      this.$fetch("/attence-api/blade-system/param/getSystemParam", {
        key: 'WORK_OVERTIME_PROMPT'
      }).then(res => {
        const data = res.data;
        if (data != null) {
          this.workovertimeTypeRemark = data;
        }
      });
    },
    workovertimeTypeClick(item) {
      this.workovertimeTypeShow = false;
      this.workovertimeType = item.dictKey;
      this.workovertimeTypeName = item.name;
    },
    onBeginConfirm(date) {
      this.beginTime = moment(date).format("YYYY-MM-DD");
      this.endTime = '';
      this.showBeginCalendar = false;
    },
    onEndConfirm(date) {
      if (this.beginTime == '') {
        Toast('请先选择开始时间');
      } else {
        if (date.getTime() >= Date.parse(this.beginTime.replace(/\-/g, '/') + ' 00:00:00')) {
          this.endTime = moment(date).format("YYYY-MM-DD");
          this.computeDays();
        } else {
          this.endTime = '';
          Toast('结束时间必须大于等于开始时间');
        }
      }

      this.showEndCalendar = false;
    },
    computeDays() {
      let a1 = Date.parse(this.beginTime);
      let a2 = Date.parse(this.endTime);
      let days = parseInt((a2 - a1) / (1000 * 60 * 60 * 24));

      this.day = days + 1;
      //如果是同一天则放开时间段选项
      if (this.beginTime == this.endTime) {
        this.dayHalf = '0';
        this.isHalfShow = true;
      } else {
        this.isHalfShow = false;
      }
    },
    onClickLeft: function () {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/workovertime/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    halfChange() {
      if (this.dayHalf == 0) {
        this.day = 1;
      } else {
        this.day = 0.5;
      }
    },
    // 返回布尔值
    beforeApplyFileRead(file) {
      return true;
    },
    afterApplyFileRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizColumn', 'applyFiles');
      this.$filePost("/attence-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.applyFileIds.push(data.id);
          this.allFiles.applyFiles.push(data);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeApplyFileDelete(file, detail) {
      let index = JSON.stringify(detail.index);
      let delId = this.applyFileIds[index];
      let url = "/attence-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.applyFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.applyFileIds);
        },
        error => {
        }
      );
      return true;
    },
    taskSave() {
      if (this.workovertimeType == '') {
        Toast('请选择加班类型');
        return;
      }

      if (this.beginTime == '' || this.endTime == '') {
        Toast('请选择加班时间');
        return;
      }

      if (this.reason == '') {
        Toast('请填写加班原因');
        return;
      }

      const params = {
        id: this.workOvertimeId,
        appNo: this.appNo, //加班流程编号
        beginTime: this.beginTime, //加班人开始时间
        endTime: this.endTime, //加班人结束时间
        reason: this.reason, //加班原因
        day: this.day, //加班天数
        halfDay: this.dayHalf, //0全部 1上午 2下午
        createTime: "", //申请时间
        status: 0, //加班流程状态流程状态为已保存
        workovertimeType: this.workovertimeType, //加班类型 1自主加班 2组织加班
        allFiles: this.allFiles,
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };
      this.workOverForm.id = this.workOvertimeId;
      this.workOverForm.appNo = this.appNo;
      this.workOverForm.beginTime = this.beginTime;
      this.workOverForm.endTime = this.endTime;
      this.workOverForm.reason = this.reason;
      this.workOverForm.day = this.day;
      this.workOverForm.halfDay = this.dayHalf;
      this.workOverForm.status = 0;
      this.workOverForm.workovertimeType = this.workovertimeType;
      this.workOverForm.allFiles = this.allFiles;
      this.workOverForm.taskId = this.taskId;
      this.workOverForm.processInstanceId = this.processInstanceId;
      this.workOverForm.processDefinitionId = this.processDefinitionId;
      //流程参数
      this.workOverForm.flow = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };
      this.workOverForm.selectedRole = this.choseRoleId;
      this.$bodyPost("/attence-api/blade-workovertime/workovertime/submit", this.workOverForm).then(resp => {
        Toast("数据保存成功");
        this.$router.push({
          path: "/attenceflow/workovertime/list",
          query: {}
        });
      }, error => {

      });
    },
    taskSubmit() {
      if (this.workovertimeType == '') {
        Toast('请选择加班类型');
        return;
      }

      if (this.beginTime == '' || this.endTime == '') {
        Toast('请选择加班时间');
        return;
      }

      if (this.reason == '') {
        Toast('请填写加班原因');
        return;
      }

      this.$fetch("/attence-api/blade-user/getUserFlowRoleList", {}).then(res => {
        const data = res.data;
        this.roleList = [];
        data.forEach((v) => {
          if (v.roleFlow != undefined && v.roleFlow != "") {
            const flowLit = v.roleFlow.split("|");
            flowLit.forEach((flow) => {
              if (this.modelKey == flow) {
                this.roleList.push(v);
              }
            });
          }
        });
        if (this.roleList.length > 0) {
          if (this.roleList.length > 1) {//流程发起角色大于1个选择角色发起流程
            this.roleShow = true;
            this.roleRadio = this.roleList[0].roleAlias;
            this.choseRoleId = this.roleList[0].roleAlias;
          } else {
            this.choseRoleId = this.roleList[0].roleAlias;
            this.showProcessInfo();
          }
        } else {
          Toast('未配置流程发起角色，请联系统系管理员！');
        }
      });
    },
    roleCommit() {
      this.choseRoleId = this.roleRadio;
      this.submitFlowMethod();
    },
    choseRoleSubmit() {
      const params = {
        id: this.workOvertimeId,
        appNo: this.appNo, //加班流程编号
        beginTime: this.beginTime, //加班人开始时间
        endTime: this.endTime, //加班人结束时间
        reason: this.reason, //加班原因
        day: this.day, //加班天数
        halfDay: this.dayHalf, //0全部 1上午 2下午
        createTime: "", //申请时间
        status: 1, //加班流程状态流程状态为已提交
        workovertimeType: this.workovertimeType, //加班类型 1自主加班 2组织加班
        allFiles: this.allFiles,
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };

      this.workOverForm.id = this.workOvertimeId;
      this.workOverForm.appNo = this.appNo;
      this.workOverForm.beginTime = this.beginTime;
      this.workOverForm.endTime = this.endTime;
      this.workOverForm.reason = this.reason;
      this.workOverForm.day = this.day;
      this.workOverForm.halfDay = this.dayHalf;
      this.workOverForm.status = 1;
      this.workOverForm.workovertimeType = this.workovertimeType;
      this.workOverForm.allFiles = this.allFiles;
      this.workOverForm.taskId = this.taskId;
      this.workOverForm.processInstanceId = this.processInstanceId;
      this.workOverForm.processDefinitionId = this.processDefinitionId;

      //流程参数
      this.workOverForm.flow = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
        variables: {
          notifyUserIds: "",
          showNextUserTasks: "true",
        },
      };
      this.workOverForm.selectedRole = this.choseRoleId;
      this.$bodyPost("/attence-api/blade-workovertime/workovertime/start-process", this.workOverForm).then(resp => {
        const data = resp.data;
        Toast('流程提交成功');
        this.roleShow = false;
        this.processShow = true;
        this.jumpPage();
      });
    },
    jumpPage() {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/workovertime/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    showProcessInfo() {
      //展示对话框
      this.$refs.showProcessDialog.showProcessInfo();
      this.roleShow = false;
    },
    submitFlowMethod() {
      this.choseRoleSubmit();
    },
    getFlowParamsMethod() {
      //用于对话框展示请求接口参数
      const params = {
        businessId: this.workOvertimeId,
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        flag: 'ok',
        processDefinitionKey: this.modelKey,
        variables: {
          auditStatus: " ",
          roleType: this.choseRoleId,
        },
      };

      return params;
    },
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

.login-form-top {
  margin-top: 0px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/workovertime/form.vue